import React, { Component } from 'react';
import { Table, Grid, Dimmer, Loader, Accordion, Icon, Dropdown, Button } from 'semantic-ui-react';
import SearchElement from './SearchElement';
import { css } from 'emotion';
import { Link } from "react-router-dom";
import {
  getRequestHeadersService,
  getDepartmentsByUser,
  getWorkSheet,
  getWorkSheetBySearchCriteria
} from "../../services/offpriceServices";
const style = css`
  &.create-cdp-home-color {
    background: #35c9ae14!important;
    color: rgba(0,0,0,.95)!important;
  }`

import { connect } from "react-redux";
import { storeCriteria, clearCriteria, softDeleteCriteria } from "../redux/actions/SearchCritriaAction"

class SearchWorksheet extends Component {
    state = {finalSearchCriteria:[],
            loading: true,
            worksheetList: [],
            activeIndex:1
            };

    currentRowIndex =-1;

    handleClick = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index
    
        this.setState({ ...this.state, activeIndex: newIndex })
    }

    componentDidUpdate(prevProps) {

        if(prevProps.homeLinkClicked != this.props.homeLinkClicked)
        {
            this.setState({...this.state, activeIndex:1, finalSearchCriteria:this.props.storedCriteria});
            this.loadWorksheetList();
        }
    }

    componentDidMount() {
        if(this.props.storedCriteria.length>0)
        {
            if(this.props.criteriaDeletedBy!="RESET")
            {
                this.setState({...this.state, activeIndex:0, finalSearchCriteria:this.props.storedCriteria});
                const payload = this.buildSearchPayload(this.props.storedCriteria);
                this.loadWorkSheetBySearchCriteria(payload);
            }
            else{
                this.setState({...this.state, activeIndex:0});
                const payload = this.buildSearchPayload(this.props.storedCriteria);
                this.loadWorkSheetBySearchCriteria(payload);
            }
           
        }
        else{
            this.loadWorksheetList();
        }
    }

    loadWorksheetList= ()=> {
        this.setState({...this.state, loading: true, activeIndex:1,  finalSearchCriteria:this.props.storedCriteria});
    
        Promise.all([
            getRequestHeadersService(),
          getDepartmentsByUser()
        ]).then(([worksheet, departments]) => {
            let worksheetData = [];
    
            if (Array.isArray(worksheet.data)) {
            worksheetData = worksheet.data;
        }
    
        if (Array.isArray(departments.data) && departments.data.length) {
            worksheetData = worksheetData.filter(({ DeptNo }) =>
                departments.data.includes(DeptNo.toString())
            );
        }
    
        this.setState({...this.state,
            loading: false,
            worksheetList: worksheetData
            });
        });
      }
    
    
    loadWorkSheetBySearchCriteria = (payload) => {
        this.setState({ loading: true });
            Promise.resolve(getWorkSheetBySearchCriteria(payload)).then((worksheet) =>{
                this.setState({
                loading: false,
                worksheetList: worksheet.data
            });
        });
    }

    onSearchParamChange = (event, data) => {    
        const selectedElement = this.searchParameters.filter((element) => element.value==data.value);
        const finalSearchCriteria= this.state.finalSearchCriteria;
        finalSearchCriteria[this.currentRowIndex] = selectedElement[0];
        this.setState({finalSearchCriteria});
    }

    setCurrentRowIndex = (rowIndex) => {
        this.currentRowIndex= rowIndex;
    }

    updateFinalSearchCriteria = (currentRowIndex, currentOption, givenValue) => {
        const finalSearchCriteria= this.state.finalSearchCriteria;
        finalSearchCriteria[currentRowIndex] =  {...currentOption, givenValue};
        this.setState({...this.state, finalSearchCriteria});
    }
    
    clearSearch=() => {
        const finalSearchCriteria=[];
        this.setState({finalSearchCriteria});
        this.props.softDeleteCriteria("RESET");
    }

    getWorksheetSearchResults = () =>
    {
        const payload = this.buildSearchPayload(this.state.finalSearchCriteria);
        this.loadWorkSheetBySearchCriteria(payload);
        this.props.storeCriteria(this.state.finalSearchCriteria)
    }

    buildSearchPayload = (searchCriterias) =>
    {
        const finalSearchPayload = [];
        searchCriterias.map((searchCriteria) =>{
            if(searchCriteria.givenValue != undefined){
            const criteria = {fieldName:searchCriteria.key, value:searchCriteria.givenValue, dataType:searchCriteria.ftype, operator:searchCriteria.operator};
            finalSearchPayload.push(criteria);
            }
        });
        return finalSearchPayload;
    }

    buildCrieriaRows = () => {
        const rows =[];
        for (let i = 0; i < 3; i++) {
            rows.push(
                <Table.Row>
                    <Table.Cell>
                        <Dropdown
                            placeholder='Select Parameter'
                            selection
                            options={this.searchParameters}
                            onChange={ this.onSearchParamChange}
                            onFocus={() => this.setCurrentRowIndex(i)}
                            value={this.state.finalSearchCriteria[i]?this.state.finalSearchCriteria[i].value:"None"}
                            text={this.state.finalSearchCriteria[i]?this.state.finalSearchCriteria[i].text:"None"}
                        />
                    </Table.Cell>
                        <Table.Cell textAlign='center'>
                            {this.state.finalSearchCriteria[i]?this.state.finalSearchCriteria[i].operator:""}
                        </Table.Cell>
                        <Table.Cell>
                            <SearchElement currentRowIndex={i} 
                            currentOption={this.state.finalSearchCriteria[i]? this.state.finalSearchCriteria[i]: undefined} 
                            updateFinalSearchCriteria={this.updateFinalSearchCriteria}/>
                    </Table.Cell>
                </Table.Row>
            )
        }
        return (
            <Table celled structured >
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Search Criteria</Table.HeaderCell>
                    <Table.HeaderCell></Table.HeaderCell>
                    <Table.HeaderCell>Value</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>{rows}</Table.Body></Table>)
    }
    searchParameters = [
        {key:"None", text:"None", value:"None", fType:"undefined", operator:""},
        {key:"RequestHeaderName", text:"Worksheet Name", value:"WorksheetName",ftype:"text", operator:"like"},
        {key:"PurchaseOrderNumber", text:"PO #", value:"PONumber", ftype:"number", operator:"=" },
        {key:"DeptNo", text:"Dept", value:"Dept", ftype:"number", operator:"="},
        {key:"VendorNo", text:"Vendor", value:"VendorNumber", ftype:"number", operator:"=" },
        {key:"Status", text:"Worksheet Status", value:"WorksheetStatus", ftype:"text", operator:"like" },
        {key:"IndcDate", text:"In DC date", value:"InDCDate", ftype:"date", operator:">=" },
        {key:"CancelDate", text:"Cancel date", value:"CancelDate", ftype:"date", operator:">=" },
        {key:"DistroByDate", text:"Distro by date", value:"CanceDistroByDatelDate", ftype:"date", operator:">=" },
        {key:"CreatedByDisplayName", text:"Owner", value:"CreatedBy", ftype:"text", operator:"like" },
        {key:"PoDesc", text:"PO Desc", value:"PoDesc", ftype:"text", operator:"like" }
    ];

    render() {
        const { loading, worksheetList, activeIndex } = this.state;

        return (
        <Grid padded>
        <Grid.Row>
            <Grid.Column width={16}>
                <Accordion>
                    <Accordion.Title
                    active={activeIndex === 0}
                    index={0}
                    onClick={this.handleClick}>
                    <Icon name='dropdown' />
                    Search Worksheet
                    </Accordion.Title>
                    <Accordion.Content active={activeIndex === 0}>
                    <p>
                        <Grid>
                            <Grid.Row columns={2}>
                                <Grid.Column>
                                    {this.buildCrieriaRows()}
                                </Grid.Column>
                                <Grid.Column verticalAlign="bottom">
                                    <Button onClick={this.getWorksheetSearchResults} class="ui blue button">
                                        <a>Search </a>
                                    </Button>                               
                                        &nbsp; &nbsp; &nbsp;
                                    <Button onClick={this.clearSearch}>
                                        Reset
                                    </Button>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </p>
                    </Accordion.Content>
                </Accordion>
            </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={16}>
            {
                loading ? (
                    <Dimmer active inverted inline="centered">
                      <Loader />
                    </Dimmer>
                  ):
            <Table selectable celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Worksheet Name</Table.HeaderCell>
                  <Table.HeaderCell>PO #</Table.HeaderCell>
                  <Table.HeaderCell>Dept</Table.HeaderCell>
                  <Table.HeaderCell>Vendor</Table.HeaderCell>
                  <Table.HeaderCell>Worksheet Status</Table.HeaderCell>
                  <Table.HeaderCell>In DC date</Table.HeaderCell>
                  <Table.HeaderCell>Cancel date</Table.HeaderCell>
                  <Table.HeaderCell>Distro date</Table.HeaderCell>
                  <Table.HeaderCell>Owner</Table.HeaderCell>
                  <Table.HeaderCell>PO Desc</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              { worksheetList.length ? 
              (<Table.Body>
                {worksheetList.map(
                  ({
                    RequestHeaderId: id,
                    RequestHeaderName: worksheetName,
                    PurchaseOrderNumber,
                    DeptNo,
                    VendorNo,
                    Status,
                    IndcDate,
                    CancelDate,
                    DistroByDate,
                    CreatedByDisplayName: owner,
                    PoDesc,
                    WrkSheetTypeId
                  }) => (
                    <Table.Row key={id} className={`${style} ${WrkSheetTypeId == 2 ? " create-cdp-home-color" : ""}  `}>
                      <Table.Cell width={30}>
                      { WrkSheetTypeId == 2 ?
                        <Link to={`cdp-products/${id}`}>{worksheetName}</Link>
                        : <Link to={`products/${id}`}>{worksheetName}</Link> } 
                      </Table.Cell>
                      <Table.Cell>{PurchaseOrderNumber}</Table.Cell>
                      <Table.Cell>{DeptNo}</Table.Cell>
                      <Table.Cell>{VendorNo}</Table.Cell>
                      <Table.Cell>{Status}</Table.Cell>
                      <Table.Cell>{(new Date(IndcDate)).toLocaleDateString() }</Table.Cell>
                      <Table.Cell>{(new Date(CancelDate)).toLocaleDateString() }</Table.Cell>
                      <Table.Cell>{(new Date(DistroByDate)).toLocaleDateString() }</Table.Cell>
                      <Table.Cell>{owner}</Table.Cell>
                      <Table.Cell width={20}>{PoDesc}</Table.Cell>
                    </Table.Row>
                  )
                )}
              </Table.Body>): 
              <Table.Body>
                <Table.Row>
                <Table.Cell> No results found </Table.Cell>
                </Table.Row>
              </Table.Body>
            }
            </Table>
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
     );
    }
}

const mapStateToProps = (reduxState) => {
    console.log("Stored criteira" + reduxState.storedSearchCriteria);
     return {storedCriteria: reduxState.storedSearchCriteria,
        criteriaDeletedBy: reduxState.criteriaDeletedBy,
        homeLinkClicked:reduxState.homeLinkClicked }
};

export default connect(mapStateToProps, {storeCriteria, clearCriteria, softDeleteCriteria}) (SearchWorksheet);


// WEBPACK FOOTER //
// ./components/home/SearchWorksheet.js